import Popup from "../common/Popup"
import React, { useEffect, useMemo, useState } from "react";
import ReactDOM from "react-dom";
import { DKLabel, DKButton, DKSpinner, DKInput, showToast, TOAST_TYPE, showLoader, removeLoader,INPUT_VIEW_DIRECTION,DKIcons } from "deskera-ui-library"
import { Document, Page, pdfjs } from 'react-pdf';
import { SizeMe } from 'react-sizeme';
import Utility from "../../utility/Utility";
import DocumentService from "../../services/DocumentService";
import RouteManager from "../../managers/RouteManager";
import { DESIGNER_TEMPLATE, INPUT_TYPE } from "../../constants/Constant";
import ApiConstants from "../../constants/ApiConstants";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import { saveAs } from 'file-saver';
import JSZip from "jszip";
import { downloadAsZip, showAccessDeniedAlert } from "../../managers/common/CommonUtil";
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";

const PayslipDesign = (props) => {

  const [showPopup, setPopup] = useState(false);
  const [tempFileBuffer, setTempFileBuffer] = useState(null);
  const [numPages, setNumPages] = useState(0);
  const [pdfBlob, setPdfBlob] = useState('');
  const [preview, setPreview] = useState(true);
  const [documentPrintUUID, setDocumentPrintUUID] = useState(null);
  const [selectedTemplate, setSelectedTemplate] = useState(null)
  const [isPDFLoading, setIsPDFLoading] = useState(false);
  const [templateValue, setTemplateValue] = useState(null);
  const [templateList, setTemplateList] = useState([])
  const [refresh, setRefresh] = useState(null);
  const [count, setCount] = useState(false)
  const [templatePrintInfo, setTemplatePrintInfo] = useState()
  const [isSettingDefault, setIsSettingDefault] = useState(false);
  const cleanup = () => {
    setTempFileBuffer(null);

  };
  const isAdmin = TenantService.get(TENANT.IS_ADMIN);
  useEffect(()=>{
    if(props.documentUpdateCountRefresh !=0) {
      setRefresh(!refresh)
    }
    
  },[props.documentUpdateCountRefresh]);

  const file = useMemo(() => ({ data: tempFileBuffer }), [tempFileBuffer]);
  useEffect(() => {
    async function printCustomInvoice(templateId) {
      if (!documentPrintUUID) {
        return;
      }

      setIsPDFLoading(true);
      try {
        let UUID = (templateValue && templateValue.id) ? `?tid=${templateValue.id}`:''
        const responseBody = await DocumentService.printDocByUID(documentPrintUUID+UUID);
        
        let responseBlob;
        if (props.isPayrollCheque) {
            const workPeriod = DocumentService.getWorkPeriod(props.payload.extra.workPeriod);
            responseBlob = new File([responseBody], `${props.payload.extra.employeeName}_${workPeriod}_Check.pdf`);
        } else {
            responseBlob = new File([responseBody], 'Payslip.pdf');            
        }

        setPdfBlob(responseBlob);
        
        const fileReader = new FileReader();
        fileReader.onloadend = (loadEvent) => {
          const bufferValue = new Uint8Array(loadEvent.target.result);
          setTempFileBuffer(bufferValue);
          setIsPDFLoading(false);
        };
        fileReader.readAsArrayBuffer(responseBlob);

      } catch (err) {
        console.error('error printing document: ', err);
        setIsPDFLoading(false);
      }

    }
    if (documentPrintUUID) {
      printCustomInvoice(null);
    }
  }, [templateValue]);

    useEffect(() => {
        pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
        async function getTemplatePrintInfo() {
            let payload;
            if (props.isPayrollCheque) {
                payload = props.payload.body;
            } else {
                payload = props.payload;
            }

            if (!payload) {
                return
            }

            try {
                setIsPDFLoading(true);
                let isRefresh = (count && isAdmin) ? true : false
                setCount(false)

                let res;
                if (props.isPayrollCheque) {
                    res = await DocumentService.checkPrintInfo(payload, isRefresh);
                } else {
                    res = await DocumentService.printInfo(payload, isRefresh);
                }

                if (res.code) {
                    setDocumentPrintUUID(res.code)
                    let documentTemplates = [
                        {
                            templateName: props.isPayrollCheque ? "Payroll Check Default Template" : "Payslip Default Template",
                            id: null
                        },
                        ...res.documentTemplates
                    ]
                    let defaultSelected = 0;
                    if (res.documentTemplates && res.documentTemplates.length !== 0) {
                        let ind = documentTemplates.findIndex(r => (r.defaultTemplate))
                        if (ind != -1) {
                            defaultSelected = ind
                        }
                    }
                    setTemplatePrintInfo(res)
                    setTemplateValue(documentTemplates[defaultSelected])
                    setTemplateList(documentTemplates)
                } else {
                    showToast("Error loding template list", TOAST_TYPE.FAILURE);
                }
            } catch (err) {
                setIsPDFLoading(false);
                console.error('error loding template list: ', err);
                showToast("Error loding template list", TOAST_TYPE.FAILURE);
            }
        }
        getTemplatePrintInfo();
        return () => {
            cleanup();
        };
    }, [refresh]);
    useEffect(() => {
      if (templatePrintInfo) {
        setIsSettingDefault(false);
      }
    }, [templatePrintInfo]);
  
    const showDefaultButton = () => {
      const loadedTemplate = templateList?.find(
        (template) => template.id === templateValue?.id
      );
      if(!templateValue?.id || !isAdmin) {
        return false
      }
  
      return (
        templateValue?.id && !isPDFLoading && (templateValue.id !== (templateList.find(t=> t.defaultTemplate)?.id))
        
      );
    };
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };
  const popUp = () => {
    return (
      <div className="transparent-background">
        <div
          id="dk-form-popup-window"
          className="popup-window"
          style={{ padding: 24, overflowY: "hidden", maxWidth: 800 }}
        >
          <div
            className={`popup-wrapper parent-width parent-height `}

          >
            {payslip()}

          </div>
        </div>
      </div>
    )
  }


  const document = () => {
    return (<SizeMe>
      {({ size }) => (
        <Document
          file={file}
          onLoadSuccess={onDocumentLoadSuccess}
          loading={''}
          className="w-full mx-2"
        >
          {Array.from(new Array(numPages), (el, index) => (
            <Page
              width={size.width ? size.width : 1}
              key={`page_${index + 1}`}
              pageNumber={index + 1}
              loading={''}
            />
          ))}
        </Document>
      )}
    </SizeMe>)

  }
  const onClose = () => {
    if (props.onClose) {
      props.onClose()
    }
  }
  const print = () => {
    if (pdfBlob !== '') {
      const responseBlob = new Blob([pdfBlob], {
        type: 'application/pdf'
      });
      const fileURL = URL.createObjectURL(responseBlob);
      window.open(fileURL, '_blank');
      setPreview(false);
    }
  }

  const download = () => {
    if (pdfBlob !== '') {
        saveAs(pdfBlob);
        setPreview(false);
      }
  }

  const onRefresh = () =>{
    if(!count) {
      setCount(true)
      setRefresh(!refresh)
    }
  }

  const downloadZip = () => {    
    const arr = [];
    arr.push(pdfBlob);
    downloadAsZip(arr, "Payperiod.zip")
  }

  const payslip = () => {
    return <>
      <div className="row justify-content-between ">
        <DKLabel className="fw-m fs-m" text="Preview" />
        <div className="d-flex">
          <DKButton className=" border-radius-m   bg-gray1 border-m mr-m" title="Close" onClick={() => { onClose() }} />
          {isAdmin && <DKButton className="text-app border-m mr-m" title="Refresh" disabled={isPDFLoading} onClick={() => { onRefresh() }} />}
          {!props.isPayrollCheque && <DKButton className={`text-white  ${isPDFLoading ? "bg-gray" : "bg-app"} `} title="Print" disabled={isPDFLoading} onClick={() => { print() }} />}
          {props.isPayrollCheque && <DKButton className={`text-white  ${isPDFLoading ? "bg-gray" : "bg-app"} `} title="Download" disabled={isPDFLoading} onClick={() => { download() }} />}
        </div>
      </div>
       <div className="pb-l">
       {isAdmin && <div className="row"><div className="web-width-40">
            <DKInput
                title=""
                className=""
                value={templateValue}
                type={INPUT_TYPE.DROPDOWN}
                showError={true}
                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                readOnly={false}
                required={false}
                formatter={(obj) => obj.templateName}
                canValidate={false}
                dropdownConfig={{
                    className: "",
                    style: {},
                    allowSearch: false,
                    searchableKey: undefined,
                    data: templateList,
                    renderer: (index, obj) => {
                        return (
                            <DKLabel
                                text={`${obj.templateName}`}
                            />
                        );
                    },
                    onSelect: (ind, value) => {
                        setTemplateValue(value)
                    },
                    button: {
                        title: 'Edit Template',
                        icon: DKIcons.white.ic_edit,
                        className: 'bg-button text-white',
                        onClick: () => {
                            if (PermissionUtils.hasAccess(MODULE.SALARY, ACTION.EDIT)) {
                                if (documentPrintUUID) {
                                    const tid = (templateValue && templateValue.id) ? `?tid=${templateValue.id}` : ''
                                    const url = ApiConstants.PRODUCT_URL_DOCUMENT_BUILDER + documentPrintUUID + tid;
                                    window.open(url, "_blank");
                                }
                            } else {
                                showAccessDeniedAlert();
                            }
                        }
                    }
                }}
                onChange={(value) => { }}
            />
        </div>
           {
            showDefaultButton() && 
           
            <DKButton
              title={'Set as default template'}
              className={`bg-white ml-s fw-m 
              
               ${ isSettingDefault ? 'text-gray' : 'text-blue'}
              
              `
            }
              style={{  textDecoration: 'underline' }}
              disabled={isSettingDefault}
              onClick={() => {
                if (templateValue.id) {
                  DocumentService.defaultTemplate(templateValue.id).then(res => {
                    onRefresh()
                  },error => {
                    showToast('Something went wrong', TOAST_TYPE.FAILURE)
                  })
                }
                
              }}
            />
  }
  </div>}
          
      </div>
      <div className={`document-view py-s custom-scroll ${isPDFLoading?'':'doc-showdow'} `} style={{
        scrollbarWidth: "thin"
      }}>
        {!isPDFLoading && document()}
        {isPDFLoading && (
          <div className="d-flex  items-center justify-content-center align-items-center parent-height">
            <DKSpinner

              className="ml-m"
              title="loading document..."
            />
          </div>
        )}
      </div>
    </>
  }
  return (
    <>
      {popUp()}
    </>

  )
}
export default PayslipDesign